/* eslint-disable */
// @ts-nocheck

/**
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as EdukitaPaulaBackendGaragecacheEntities from '../garagecache/entities.pb';
import * as EdukitaPaulaBackendGaragecacheProfiles from '../garagecache/profiles.pb';
import * as EdukitaPaulaBackendV3Common from './common.pb';
import * as fm from '@generated/fetch.pb';

export enum AttendanceStatus {
    ATTENDANCE_STATUS_UNSPECIFIED = 'ATTENDANCE_STATUS_UNSPECIFIED',
    PRESENT = 'PRESENT',
    ABSENT = 'ABSENT',
    NOT_RUNNING_YET = 'NOT_RUNNING_YET',
}

export type LevelTracker = {
    id?: number;
    garageStudentId?: number;
    garageLevelLabel?: string;
    garagePartnerId?: number;
    garagePartnerInfo?: EdukitaPaulaBackendGaragecacheEntities.GaragePartnerInfo;
    garageStudentProfile?: EdukitaPaulaBackendGaragecacheProfiles.GarageStudentProfile;
    garageParentProfile?: EdukitaPaulaBackendGaragecacheProfiles.GarageParentProfile;
    garageTeacherProfiles?: EdukitaPaulaBackendGaragecacheProfiles.GarageTeacherProfile[];
    academicMonth?: string;
    tenureDurationInMonth?: number;
    teacherIds?: number[];
    averageScore?: number;
    emergingPercentage?: number;
    developingPercentage?: number;
    expandingPercentage?: number;
    recommendation?: string;
    teacherRemarks?: string;
    flagToParents?: boolean;
    attendanceNeedAttention?: boolean;
    levelStartDate?: string;
    learningObjectivesProgress?: LearningObjectiveProgress[];
    attendanceSessions?: EdukitaPaulaBackendV3Common.AttendanceSession[];
    skillAssessedPercentage?: number;
    attendance?: EdukitaPaulaBackendV3Common.AttendanceCounts;
};

export type GetLevelTrackersRequest = {
    garageStudentId?: number;
    page?: number;
    pageSize?: number;
    withLevelLoProgress?: boolean;
};

export type GetLevelTrackersResponse = {
    levelTrackers?: LevelTracker[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
};

export type LearningObjectiveProgress = {
    loCode?: string;
    loTitle?: string;
    assessed?: boolean;
    assessmentsCount?: number;
    averageScore?: number;
    competencyLevel?: string;
};

export class LevelTrackerService {
    static GetLevelTrackers(
        this: void,
        req: GetLevelTrackersRequest,
        initReq?: fm.InitReq
    ): Promise<GetLevelTrackersResponse> {
        return fm.fetchRequest<GetLevelTrackersResponse>(
            `/v3/level-trackers?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
}
